"use strict";

jQuery(($) => {
	// Put pure JS here!
	// Modal activation
	{
		const $modal = $('#SearchModal');
		const $searchBtn = $('#search');
		const $closeBtn = $($modal).find('.search-modal__close');

		$searchBtn.on('click', () => {
			toggleModal();
		});

		$closeBtn.on('click', () => {
			toggleModal();
			$($searchBtn).focus();
		});

		$modal.on('click', (e) => {
			if (e.target.nodeName !== 'INPUT' && e.target.nodeName !== 'BUTTON') {
				toggleModal();
			}
		});

		function toggleModal() {
			const $modal = $('#SearchModal');
			const $input = $($modal).find('input[name="s"]');

			$($modal).toggleClass('active');
			$($input).focus();
		}
	}

	// Mobile nav menu active menu-item
	{
		const $mobile_menu = $("aside.touch-menu");

		if ($mobile_menu) {
			const container = $mobile_menu[0];
			const menuContainers = $(container).find("nav > div");
			const subMenus = $(container).find('.sub-menu');

			// Hide sub-menus
			for (let i=0; i < subMenus.length; i++) {
				$(subMenus[i]).hide();
			}

			// Get all of the items that have a submenu and listen for a click
			for (let i=0; i < menuContainers.length; i++) {
				const menu = menuContainers[i];
				const parentLis = $(menu).find(".menu-item-has-children");

				for (let i=0; i < parentLis.length; i++) {
					const parentNavItem = parentLis[i];

					$(parentNavItem).on("click", function(e) {
						e.stopPropagation();
						const childMenu = $(this).children('ul.sub-menu');

						// If it's currently active and they click again, let them go to the link
						if ($(this).hasClass('currently_active')) {
							return;
						} else {
							e.preventDefault();

							if (childMenu) {
								$(childMenu[0]).show();
							}

							$(this).addClass('currently_active');
						}
					});

					if ($(parentNavItem).hasClass('current-menu-item') || $(parentNavItem).hasClass('current-menu-ancestor')) {
						// $(parentNavItem).addClass('currently_active');
						$(parentNavItem).click();
					}
				}
			}
		}

	}

	// ul columnizer
	{
		const lists = $('ul');

		if (lists) {
			for (let i=0; i<lists.length; i++) {
				const listItems = $(lists[i]).children('li');

				if (listItems.length >= 10) {
					$(lists[i]).addClass('split');
				}
			}
		}
	}
});